(function () {
  'use strict';

  if (!document.documentElement.classList.contains('ssp-mobile-ux')) return;

  var mobileQuery = window.matchMedia('(max-width: 767px)');
  var narrowQuery = window.matchMedia('(max-width: 575px)');

  function normalize(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function relocateHomeCopy() {
    if (!narrowQuery.matches || !document.body.classList.contains('template-index')) return;
    var copy = document.querySelector('.ssp-home-owner__copy:not(.ssp-home-owner__copy--relocated)');
    var firstCollection = document.querySelector('main .featured-collection');
    if (!copy || !firstCollection) return;

    var anchor = firstCollection.closest('.shopify-section') || firstCollection;
    var detail = document.createElement('section');
    detail.className = 'ssp-home-detail';
    detail.setAttribute('aria-label', 'How we select and describe pearls');
    copy.classList.add('ssp-home-owner__copy--relocated');
    detail.appendChild(copy);
    anchor.insertAdjacentElement('afterend', detail);
  }

  function syncLocaleBanner() {
    var banner = document.getElementById('ssp-locale-banner');
    if (!banner) return;

    var update = function () {
      var visible = !banner.hidden && banner.getBoundingClientRect().height > 0;
      document.documentElement.classList.toggle('ssp-locale-banner-visible', visible);
      if (visible) {
        document.documentElement.style.setProperty(
          '--ssp-locale-banner-height',
          Math.ceil(banner.getBoundingClientRect().height) + 'px'
        );
      } else {
        document.documentElement.style.removeProperty('--ssp-locale-banner-height');
      }
    };

    new MutationObserver(update).observe(banner, {
      attributes: true,
      attributeFilter: ['hidden', 'style', 'class'],
      childList: true
    });
    update();
  }

  function enhanceGTranslate(root) {
    if (!mobileQuery.matches) return false;
    var switcher = (root || document).querySelector('.gt_switcher');
    if (!switcher || switcher.dataset.sspMobileReady === 'true') return false;
    var selected = switcher.querySelector('.gt_selected > a');
    var option = switcher.querySelector('.gt_option');
    if (!selected || !option) return false;

    switcher.dataset.sspMobileReady = 'true';
    selected.setAttribute('aria-label', 'Choose language');
    selected.setAttribute('title', 'Choose language');

    var links = Array.prototype.slice.call(option.querySelectorAll(':scope > a[data-gt-lang]'));
    var preferred = [
      'en', 'es', 'fr', 'de', 'it', 'pt', 'nl', 'ja', 'zh-CN',
      'ko', 'ar', 'ru', 'pl', 'sv', 'tr', 'id', 'vi', 'el'
    ];
    var aliases = {
      en: 'english ingles anglais englisch',
      es: 'spanish espanol español castellano',
      fr: 'french francais français',
      de: 'german deutsch aleman alemán',
      it: 'italian italiano',
      pt: 'portuguese portugues português',
      nl: 'dutch nederlands neerlandes neerlandés',
      ja: 'japanese japanese nihongo 日本語',
      'zh-cn': 'chinese simplified mandarin 简体中文',
      ko: 'korean 한국어',
      ar: 'arabic العربية',
      ru: 'russian русский',
      pl: 'polish polski',
      sv: 'swedish svenska',
      tr: 'turkish turkce türkçe',
      id: 'indonesian bahasa indonesia',
      vi: 'vietnamese tieng viet tiếng việt',
      el: 'greek ελληνικά'
    };

    var reorderLinks = function () {
      links = Array.prototype.slice.call(option.querySelectorAll(':scope > a[data-gt-lang]'));
      var priority = preferred.map(function (code) { return code.toLocaleLowerCase(); });
      var ordered = links.slice().sort(function (left, right) {
        var leftCode = String(left.getAttribute('data-gt-lang')).toLocaleLowerCase();
        var rightCode = String(right.getAttribute('data-gt-lang')).toLocaleLowerCase();
        var leftIndex = priority.indexOf(leftCode);
        var rightIndex = priority.indexOf(rightCode);
        if (leftIndex === -1) leftIndex = priority.length;
        if (rightIndex === -1) rightIndex = priority.length;
        return leftIndex - rightIndex;
      });
      var changed = ordered.some(function (link, index) { return links[index] !== link; });
      if (changed) ordered.forEach(function (link) { option.appendChild(link); });
      links = ordered;
    };
    reorderLinks();

    var wrap = document.createElement('label');
    wrap.className = 'ssp-gt-search-wrap';
    var input = document.createElement('input');
    input.className = 'ssp-gt-search';
    input.type = 'search';
    input.placeholder = 'Search language';
    input.setAttribute('aria-label', 'Search languages');
    input.autocomplete = 'off';
    wrap.appendChild(input);

    var empty = document.createElement('div');
    empty.className = 'ssp-gt-empty';
    empty.textContent = 'No language found';
    empty.setAttribute('role', 'status');
    empty.setAttribute('aria-live', 'polite');
    option.insertBefore(empty, option.firstChild);
    option.insertBefore(wrap, option.firstChild);

    ['click', 'mousedown', 'touchstart'].forEach(function (eventName) {
      wrap.addEventListener(eventName, function (event) { event.stopPropagation(); });
    });

    input.addEventListener('input', function () {
      var query = normalize(input.value);
      var visible = 0;
      links.forEach(function (link) {
        var haystack = normalize(
          (link.getAttribute('title') || '') + ' ' +
          (link.getAttribute('data-gt-lang') || '') + ' ' +
          (aliases[String(link.getAttribute('data-gt-lang')).toLocaleLowerCase()] || '') + ' ' +
          link.textContent
        );
        var show = !query || haystack.indexOf(query) !== -1;
        link.hidden = !show;
        if (show) visible += 1;
      });
      empty.setAttribute('data-visible', visible === 0 ? 'true' : 'false');
    });

    selected.addEventListener('click', function () {
      window.setTimeout(function () {
        reorderLinks();
        if (getComputedStyle(option).display !== 'none') input.focus({ preventScroll: true });
      }, 0);
    });
    var reorderTimer;
    new MutationObserver(function () {
      window.clearTimeout(reorderTimer);
      reorderTimer = window.setTimeout(reorderLinks, 0);
    }).observe(option, { childList: true });
    return true;
  }

  function observeGTranslate() {
    if (enhanceGTranslate(document)) return;
    var observer = new MutationObserver(function () {
      if (enhanceGTranslate(document)) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  function improveExactControls() {
    var whatsApp = document.getElementById('ssp-whatsapp-btn');
    if (whatsApp) {
      whatsApp.setAttribute('aria-label', 'Chat on WhatsApp');
      whatsApp.setAttribute('title', 'Chat on WhatsApp');
    }

    var quantity = document.querySelector('.product-quantity .quantity-field');
    var quantityLabel = document.querySelector('.product-quantity .product-quantity-label');
    if (quantity && quantityLabel) {
      if (!quantity.id) quantity.id = 'product-quantity';
      quantityLabel.setAttribute('for', quantity.id);
    }
  }

  function prioritizeCartActions() {
    if (!mobileQuery.matches || !document.body.classList.contains('template-cart')) return;

    var cart = document.querySelector('.cart');
    if (!cart) return;

    var reorder = function () {
      var buttonWrapper = cart.querySelector('.cart__buttons-wrapper');
      var checkout = buttonWrapper && buttonWrapper.querySelector('.cart__checkout-button');
      var wallets = cart.querySelector('.additional-checkout-buttons');
      if (!buttonWrapper || !checkout || !wallets || wallets.parentElement === buttonWrapper) return;
      checkout.insertAdjacentElement('afterend', wallets);
    };

    reorder();
    new MutationObserver(reorder).observe(cart, { childList: true, subtree: true });
  }

  function repairRtlSkipLink() {
    if (!mobileQuery.matches || getComputedStyle(document.documentElement).direction !== 'rtl') return;
    var link = document.querySelector('.skip-to-main');
    if (!link) return;
    var properties = [
      'position', 'top', 'right', 'left', 'width', 'height', 'padding',
      'margin', 'overflow', 'clip', 'clip-path', 'white-space'
    ];
    var original = properties.map(function (property) {
      return {
        property: property,
        value: link.style.getPropertyValue(property),
        priority: link.style.getPropertyPriority(property)
      };
    });
    var restore = function () {
      original.forEach(function (item) {
        if (item.value) link.style.setProperty(item.property, item.value, item.priority);
        else link.style.removeProperty(item.property);
      });
    };
    var hide = function () {
      link.style.setProperty('position', 'fixed', 'important');
      link.style.setProperty('top', '0', 'important');
      link.style.setProperty('right', '0', 'important');
      link.style.setProperty('left', 'auto', 'important');
      link.style.setProperty('width', '1px', 'important');
      link.style.setProperty('height', '1px', 'important');
      link.style.setProperty('padding', '0', 'important');
      link.style.setProperty('margin', '-1px', 'important');
      link.style.setProperty('overflow', 'hidden', 'important');
      link.style.setProperty('clip', 'rect(0px, 0px, 0px, 0px)', 'important');
      link.style.setProperty('clip-path', 'inset(50%)', 'important');
      link.style.setProperty('white-space', 'nowrap', 'important');
    };
    link.addEventListener('focus', restore);
    link.addEventListener('blur', hide);
    hide();
  }

  function boot() {
    relocateHomeCopy();
    syncLocaleBanner();
    observeGTranslate();
    improveExactControls();
    prioritizeCartActions();
    repairRtlSkipLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
